module.exports = __webpack_public_path__ + "res/Roboto-BoldItalic-webfont.eot?f7341d7fd5a07d5c33bd731e7ad6718e";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldItalic-webfont.eot
// module id = 31
// module chunks = 0